import type { Locale } from '@headless-workspace/config';
import { SEOMetadata } from '@headless-workspace/typings';
import { LanguageHelpers, PredicateHelpers } from '@headless-workspace/utils';
import type { MetaDataSEOByKeyDTO } from './MetadataSEODTO';

/**
 * Represents an array of objects that define the HTTP-Equiv meta tags for SEO.
 */
export type MetadataHttpsEquivValue = {
    httpEquiv: string;
    content: string;
};

/**
 * Represents an array of objects that define the schema type for SEO entities.
 */
export type MetadataSchemaValue = {
    '@context': string;
    '@type': string;
    name: string;
    alternateName?: string;
    legalName?: string;
    url: string;
    sameAs?: string[];
    potentialAction?: {
        '@type': string;
        target: string;
        'query-input': string;
    };
    logo?: string;
    contactPoint?: {
        '@type': string;
        contactType: string;
        telephone: string;
        email?: string;
    };
};

export type MetadataSEOValue = SEOMetadata & {
    schemas?: MetadataSchemaValue[];
    httpsEquivs?: MetadataHttpsEquivValue[];
    alternatesLocales?: Locale[];
};

export const mapMetadataSEO = (dto: MetaDataSEOByKeyDTO): MetadataSEOValue => {
    return {
        ...dto,
        alternatesLocales: dto.alternatesLocales
            ?.map((locale) => (LanguageHelpers.isLocale(locale) ? locale : undefined))
            .filter(PredicateHelpers.notNullOrUndefined),
    };
};
